import { render, staticRenderFns } from "./AncestralTabletsEngraving.vue?vue&type=template&id=db22dc86&scoped=true&"
import script from "./AncestralTabletsEngraving.vue?vue&type=script&lang=js&"
export * from "./AncestralTabletsEngraving.vue?vue&type=script&lang=js&"
import style0 from "./AncestralTabletsEngraving.vue?vue&type=style&index=0&id=db22dc86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db22dc86",
  null
  
)

export default component.exports